import { createSlice } from '@reduxjs/toolkit';

const initialState = () => {
  return {
    cart: null,
    showCart: false,
    purchaseModalOpen: false
  };
};

export const cartReducer = createSlice({
  name: 'cart',
  initialState: { ...initialState() },
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload || [];
    },
    setShowCart: (state, action) => {
      state.showCart = action.payload;
    },
    setPurchaseModalOpen: (state, action) => {
      state.purchaseModalOpen = action.payload;
    },
    resetCart: (state) => {
      Object.assign(state, initialState());
    }
  }
});

// Action creators are generated for each case reducer function
export const { setCart, setShowCart, setPurchaseModalOpen, resetCart } = cartReducer.actions;

export default cartReducer.reducer;
